import { baseGlobals } from '@root/typescript/baseGlobals'

import { DateTime } from '../DateTime/DateTime'

import type { TReady, TEasing, TCancel, TUpdate, TProgress, ITweenResponse } from './definitions'

/**
 * Animáció indítása.
 * @param easing   - Easing.
 * @param duration - Animáció hossza.
 * @param progress - Progress minden anim lépésnél megfut.
 * @param ready    - Ready callback, ha vége az anim-nak.
 * @param cancel   - Anim megállítása, onEnd futtatás nélkül.
 * @param update   - Update callback.
 */
export default function run ( // eslint-disable-line @typescript-eslint/max-params
  easing: TEasing,
  duration: number,
  progress: TProgress,
  ready: TReady,
  cancel: TCancel,
  update?: TUpdate
): ITweenResponse {
  const startms = DateTime.now()
  const endms = startms + duration
  const diffms = endms - startms

  let isEnabled = true

  /** Az animáció egységnyi lépése. */
  function step (): void {
    if (!isEnabled) {
      return
    }

    const nowms = DateTime.now()

    const actProgress = nowms < endms ? (nowms - startms) / diffms : 1

    if (update) {
      update(actProgress)
    }

    if (nowms < endms) {
      progress(easing(actProgress))

      if (!baseGlobals.isTest) {
        window.requestAnimationFrame(step)
      }
    }
    else {
      progress(actProgress)

      ready()
    }
  }

  /** Amikor véget ér az animáció. */
  function stop (): void {
    isEnabled = false
    ready()
  }

  /** Megszakítás, de az onEnd ne fusson meg. */
  function canc (): void {
    isEnabled = false

    cancel()
  }

  // Teszt esetén egyből legyen vége
  if (baseGlobals.isTest) {
    step()
    progress(1)
    ready()
  }
  else {
    step()
  }

  return { stop, cancel: canc }
}
